import { Grid, Link } from "@mui/material"
import { crudGetList, RecordContextProvider } from "ra-core"
import { FC, useEffect } from "react"
import { useDispatch } from "react-redux"
import { Helmet } from 'react-helmet-async'
import FieldsMappingList from "~/components/settings/encryption/FieldsMappingList"
import { TableSelectionCard } from "~/components/settings/encryption/TableSelectionCard"
import { RecPatch } from "~/dataProvider/tools"
import { OdResourcePageProps } from "~/types/resource"
import { pages, sorts } from "~/utils/paramsWithGetMainList"
import { useMutateEncryptionMappingsController } from "./mutateEncryptionMappingsController"
import { MutateEncryptionMappingsContextProvider } from "./mutateEncryptionMappingsContext"
import { useResourceRegister } from "~/utils/resourceRegister"
import { decodeHashid, genUrlWithHashid } from "~/utils/hashid"
import { Content } from "~/components/content/Content"
import { Route, Switch } from "react-router-dom"
import EditNoSqlEncryptionMappings, { useSchemaReadyDatabase } from "./EditNoSqlEncryptionMappings"


const EditEncryptionMappings: FC<OdResourcePageProps & RecPatch> = (props) => {
  useResourceRegister({ name: 'db-fields-mapping-count' })
  useResourceRegister({ name: 'tables' })
  useResourceRegister({ name: 'collections' })
  useResourceRegister({ name: 'fields' })
  useResourceRegister({ name: 'collection-properties' })
  useResourceRegister({ name: 'mapping-rules' })
  const { id: hId, match, ...rest } = props
  const basePath = match ? match.path : '';
  const id = decodeHashid(hId || '')
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(
      crudGetList('encryption/mappings', pages(), sorts(), {})
    )
  }, [dispatch])

  return (
    <Switch>
      <Route path={`${basePath}/ns`}>
        <EditNoSqlEncryptionMappings id={id} {...rest} />
      </Route>
      <Route path={`${basePath}`}>
        <EditEncryptionMappingsCater id={id} {...rest} />
      </Route>
    </Switch>
  )
}

const EditEncryptionMappingsCater: FC<OdResourcePageProps & RecPatch> = (props) => {
  
  const { encryptMappingCtrl } = useMutateEncryptionMappingsController()
  
  return (
    <MutateEncryptionMappingsContextProvider value={encryptMappingCtrl}>
      <EditEncryptionMappingsBody {...props} />
    </MutateEncryptionMappingsContextProvider>
  )
}

export interface EditEncryptionMappingsBodyProps extends OdResourcePageProps, RecPatch {

}

export const EditEncryptionMappingsBody: FC<EditEncryptionMappingsBodyProps> = (({
  id,
  options,
  resource = 'encryption/mappings',
}) => {
  const databaseEm = useSchemaReadyDatabase(id)

  return (
    <Content 
      pageName="Edit Encryption Mappings" 
      resourceName="Edit Encryption Mappings" 
      breadcrumbs={[ ...(options?.breadcrumbs ?? []), { label: 'Encryption Mappings', path: `/${resource}` } ]}
      mainActions={
        databaseEm &&
        <Link href={genUrlWithHashid(`/encryption/obfs/mappings/$0/edit`, databaseEm.databaseId!, databaseEm.databaseName)} target="_blank" variant="caption"
          sx={{ mb: 1, mr: 1, display: 'inline-block' }}
        >
          Obfuscation Mappings...
        </Link>
      }
    >
      <Helmet>
        <title>Edit Encryption Mappings | OnData</title>
      </Helmet>

      <RecordContextProvider value={databaseEm}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
              <TableSelectionCard useSource="tables" />
          </Grid>
          <Grid item xs={12}>
            <FieldsMappingList />
          </Grid>
        </Grid>
      </RecordContextProvider>
    </Content>
  )
})

export default EditEncryptionMappings;
